import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { FormattedMessage } from "react-intl";

export default function ChangeAPLPeriodDateModal({
  periodName,
  isOpen,
  toggle,
  newStartDate,
  newEndDate,
  setNewStartDate,
  setNewEndDate,
  handleChangeStartOrEndDates,
}) {
  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{periodName}</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <Label className="form-label mb-1">
              <FormattedMessage id="FromDate" />
            </Label>
            <DatePicker
              selected={newStartDate}
              onChange={setNewStartDate}
              selectsStart
              startDate={newStartDate}
              endDate={newEndDate}
              dateFormat="yyyy-MM-dd"
              locale="sv"
              className="form-control text-center"
              wrapperClassName="d-block"
            />
          </Col>
          <Col xs="auto" className="d-flex align-items-end pb-2">
            –
          </Col>
          <Col>
            <Label className="form-label mb-1">
              <FormattedMessage id="ToDate" />
            </Label>
            <DatePicker
              selected={newEndDate}
              onChange={setNewEndDate}
              selectsEnd
              startDate={newStartDate}
              endDate={newEndDate}
              minDate={newStartDate}
              dateFormat="yyyy-MM-dd"
              locale="sv"
              className="form-control text-center"
              wrapperClassName="d-block"
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          onClick={() => handleChangeStartOrEndDates(newStartDate, newEndDate)}
          color="primary"
          outline
        >
          <FormattedMessage id="Continue" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
